import { gql } from '@apollo/client';
import {
  ExtTalentContactFields,
  ExtTalentFields,
  ExtTalentSocialFields,
} from './fragments';

export const ADMIN_CREATE_EXT_TALENT = gql`
  mutation AdminCreateExtTalent($input: AdminCreateExtTalentInput!) {
    adminCreateExtTalent(input: $input) {
      ...ExtTalentFields
    }
  }
  ${ExtTalentFields}
`;

export const ADMIN_UPDATE_EXT_TALENT = gql`
  mutation AdminUpdateExtTalent($input: AdminUpdateExtTalentInput!) {
    adminUpdateExtTalent(input: $input) {
      ...ExtTalentFields
    }
  }
  ${ExtTalentFields}
`;

export const ADMIN_CREATE_EXT_TALENT_SOCIAL = gql`
  mutation AdminCreateExtTalentSocial(
    $input: AdminCreateExtTalentSocialInput!
  ) {
    adminCreateExtTalentSocial(input: $input) {
      ...ExtTalentSocialFields
    }
  }
  ${ExtTalentSocialFields}
`;

export const ADMIN_UPDATE_EXT_TALENT_SOCIAL = gql`
  mutation AdminUpdateExtTalentSocial(
    $input: AdminUpdateExtTalentSocialInput!
  ) {
    adminUpdateExtTalentSocial(input: $input) {
      ...ExtTalentSocialFields
    }
  }
  ${ExtTalentSocialFields}
`;

export const ADMIN_CREATE_EXT_TALENT_CONTACT = gql`
  mutation AdminCreateExtTalentContact(
    $input: AdminCreateExtTalentContactInput!
  ) {
    adminCreateExtTalentContact(input: $input) {
      ...ExtTalentContactFields
    }
  }
  ${ExtTalentContactFields}
`;

export const ADMIN_UPDATE_EXT_TALENT_CONTACT = gql`
  mutation AdminUpdateExtTalentContact(
    $input: AdminUpdateExtTalentContactInput!
  ) {
    adminUpdateExtTalentContact(input: $input) {
      ...ExtTalentContactFields
    }
  }
  ${ExtTalentContactFields}
`;

export const ADMIN_CREATE_EXT_TALENT_AVATAR_PRESIGNED_URL = gql`
  mutation AdminCreateExtTalentAvatarPresignedUrl(
    $input: AdminCreateExtTalentAvatarUrlInput!
  ) {
    adminCreateExtTalentAvatarPresignedUrl(input: $input) {
      fields
      key
      url
    }
  }
`;
